import React, { ComponentPropsWithoutRef, FC, PropsWithChildren } from 'react';
import { ColorFunction } from '@styles/colors/types';
import { font } from '@styles/fonts';
import { TIMELINE_BLOCK_TITLE_CONFIG } from '@components/machines/components/timeline/constants';
import { Text, View } from 'react-native';
import { ContainerStyle } from '@interfaces/base';

interface TimelineBlockTitleProps extends PropsWithChildren, ContainerStyle {
  C: ColorFunction;
}

const TimelineBlockTitle: FC<TimelineBlockTitleProps> = ({ children, C, containerStyle }) => {
  return (
    <View style={[containerStyle]}>
      <Text
        style={[
          font.Headline,
          { color: C(TIMELINE_BLOCK_TITLE_CONFIG.textColor), marginBottom: TIMELINE_BLOCK_TITLE_CONFIG.marginBottom, userSelect: 'none' },
        ]}
      >
        {children}
      </Text>
    </View>
  );
};

export { TimelineBlockTitle };
